<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="changeLogNotes">
<!-- <div class="modal-content changeLogNotes"> -->
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Add Change Log Notes</h5>
    </div>

    <div class=" modal-body" style="margin-top: -1px; padding: 10px; background-color: rgb(124, 124, 124);">
        <div *ngIf="messageNotesLoaded; else loading">
            <div *ngIf="category != '' && messageNoteInfos.length > 0">
                <ng-select [items]=messageNoteInfos
                    name="MessageNotes"
                    style="width: 468px;"
                    bindLabel="note"
                    (change) = "messageNoteSelected()"
                    placeholder = "Select change note"
                    (clear) = "messageNoteSelected()"
                    [(ngModel)]="selectedNote">
                </ng-select>
            </div>

            <div *ngIf="category == '-other-' || messageNoteInfos.length < 1">
                <textarea [(ngModel)]="changeLogNotes" style="width: 100%; height: 100px; background-color: rgb(35, 35, 35); color: white;" type="text" name="changeLogNotes" ></textarea>
            </div>

            <div style="margin-top: 5px; background-color: rgb(124, 124, 124); min-height: 43px;">
                <button type="button" class="btn btn-info" (click)="saveChangeLogNotes()" style="float: right; margin-right: 1px;">Save</button>
                <button (click)="cancelChangeLogNotes()" class="btn btn-basic col-xs-5 pull-right" style="margin-right: 15px; margin-bottom: 10px; color: white;" type="button">Cancel</button>
            </div>
        </div>
    </div>
</div>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3">
        <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 20px;"></i>
        <span>Loading...</span>
    </div>
</ng-template>